// // Enhanced Product Image Zoom with Hover and Click
// // Add this to your theme's assets folder as 'product-image-zoom.js'

// class ProductImageZoom {
//   constructor() {
//     this.images = document.querySelectorAll('.product__media img, .product-media-container img');
//     this.zoomLevel = 2;
//     this.init();
//   }

//   init() {
//     this.images.forEach(img => {
//       const container = img.closest('.product__media, .product-media-container');
//       if (!container) return;

//       // Add zoom cursor
//       container.style.cursor = 'zoom-in';
      
//       // Hover zoom functionality
//       this.addHoverZoom(img, container);
      
//       // Click to open full image
//       this.addClickZoom(img);
//     });
//   }

//   addHoverZoom(img, container) {
//     let zoomOverlay = null;
//     let zoomedImage = null;

//     container.addEventListener('mouseenter', () => {
//       // Create zoom overlay
//       zoomOverlay = document.createElement('div');
//       zoomOverlay.className = 'image-zoom-overlay';
//       zoomOverlay.style.cssText = `
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         overflow: hidden;
//         pointer-events: none;
//         z-index: 10;
//       `;

//       // Create zoomed image
//       zoomedImage = document.createElement('img');
//       zoomedImage.src = img.src;
//       zoomedImage.style.cssText = `
//         position: absolute;
//         max-width: none;
//         width: ${img.naturalWidth}px;
//         height: ${img.naturalHeight}px;
//         transform-origin: top left;
//       `;

//       zoomOverlay.appendChild(zoomedImage);
//       container.style.position = 'relative';
//       container.appendChild(zoomOverlay);
//     });

//     container.addEventListener('mousemove', (e) => {
//       if (!zoomedImage || !zoomOverlay) return;

//       const rect = container.getBoundingClientRect();
//       const x = e.clientX - rect.left;
//       const y = e.clientY - rect.top;

//       // Calculate zoom position
//       const xPercent = x / rect.width;
//       const yPercent = y / rect.height;

//       const moveX = (img.naturalWidth * this.zoomLevel - rect.width) * xPercent;
//       const moveY = (img.naturalHeight * this.zoomLevel - rect.height) * yPercent;

//       zoomedImage.style.transform = `scale(${this.zoomLevel}) translate(-${moveX / this.zoomLevel}px, -${moveY / this.zoomLevel}px)`;
//     });

//     container.addEventListener('mouseleave', () => {
//       if (zoomOverlay) {
//         zoomOverlay.remove();
//         zoomOverlay = null;
//         zoomedImage = null;
//       }
//     });
//   }

//   addClickZoom(img) {
//     img.addEventListener('click', (e) => {
//       e.preventDefault();
//       this.openFullscreen(img);
//     });
//   }

//   openFullscreen(img) {
//     // Create fullscreen modal
//     const modal = document.createElement('div');
//     modal.className = 'image-zoom-modal';
//     modal.style.cssText = `
//       position: fixed;
//       top: 0;
//       left: 0;
//       width: 100%;
//       height: 100%;
//       background: rgba(0, 0, 0, 0.95);
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       z-index: 9999;
//       cursor: zoom-out;
//       animation: fadeIn 0.3s ease;
//     `;

//     // Create fullscreen image
//     const fullImg = document.createElement('img');
//     fullImg.src = img.src.replace(/_(small|medium|large|compact|grande)\./, '.'); // Get highest quality
//     fullImg.style.cssText = `
//       max-width: 90%;
//       max-height: 90%;
//       object-fit: contain;
//       animation: zoomIn 0.3s ease;
//     `;

//     // Create close button
//     const closeBtn = document.createElement('button');
//     closeBtn.innerHTML = '×';
//     closeBtn.style.cssText = `
//       position: absolute;
//       top: 20px;
//       right: 30px;
//       background: rgba(255, 255, 255, 0.9);
//       border: none;
//       border-radius: 50%;
//       width: 40px;
//       height: 40px;
//       font-size: 30px;
//       cursor: pointer;
//       z-index: 10000;
//       transition: transform 0.2s;
//     `;

//     closeBtn.addEventListener('mouseenter', () => {
//       closeBtn.style.transform = 'scale(1.1)';
//     });

//     closeBtn.addEventListener('mouseleave', () => {
//       closeBtn.style.transform = 'scale(1)';
//     });

//     // Close functionality
//     const closeModal = () => {
//       modal.style.animation = 'fadeOut 0.3s ease';
//       setTimeout(() => modal.remove(), 300);
//     };

//     closeBtn.addEventListener('click', closeModal);
//     modal.addEventListener('click', (e) => {
//       if (e.target === modal) closeModal();
//     });

//     document.addEventListener('keydown', function escClose(e) {
//       if (e.key === 'Escape') {
//         closeModal();
//         document.removeEventListener('keydown', escClose);
//       }
//     });

//     modal.appendChild(fullImg);
//     modal.appendChild(closeBtn);
//     document.body.appendChild(modal);

//     // Prevent body scroll
//     document.body.style.overflow = 'hidden';
//     modal.addEventListener('remove', () => {
//       document.body.style.overflow = '';
//     });
//   }
// }

// // Add CSS animations
// const style = document.createElement('style');
// style.textContent = `
//   @keyframes fadeIn {
//     from { opacity: 0; }
//     to { opacity: 1; }
//   }
  
//   @keyframes fadeOut {
//     from { opacity: 1; }
//     to { opacity: 0; }
//   }
  
//   @keyframes zoomIn {
//     from {
//       transform: scale(0.8);
//       opacity: 0;
//     }
//     to {
//       transform: scale(1);
//       opacity: 1;
//     }
//   }
  
//   .image-zoom-modal img {
//     box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
//   }
// `;
// document.head.appendChild(style);

// // Initialize when DOM is ready
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => {
//     new ProductImageZoom();
//   });
// } else {
//   new ProductImageZoom();
// }

// // Re-initialize on dynamic content changes (variant changes, etc.)
// document.addEventListener('product:media-changed', () => {
//   new ProductImageZoom();
// });



// Enhanced Product Image Zoom with Theme Customizer Integration
// Fixed version - reads settings from window.zoomSettings

class ProductImageZoom {
  constructor() {
    // Get settings from Liquid template or use defaults
    this.settings = window.zoomSettings || {
      enabled: true,
      hoverStyle: 'overlay',
      zoomLevel: 2,
      fullscreenEnabled: true,
      fullscreenBg: '#000000',
      fullscreenOpacity: 0.95,
      mobileEnabled: false
    };

    // Don't initialize if zoom is disabled
    if (!this.settings.enabled) return;

    // Check if mobile and if mobile zoom is disabled
    this.isMobile = window.innerWidth <= 749;
    if (this.isMobile && !this.settings.mobileEnabled) {
      // Only enable click zoom on mobile
      this.initClickOnly();
      return;
    }

    this.images = document.querySelectorAll('.product__media img, .product-media-container img');
    this.activeModal = null;
    this.originalOverflow = '';
    this.init();
  }

  init() {
    this.images.forEach(img => {
      const container = img.closest('.product__media, .product-media-container');
      if (!container) return;

      // Add zoom cursor
      container.style.cursor = 'zoom-in';
      
      // Add hover zoom if not disabled
      if (this.settings.hoverStyle !== 'disabled') {
        this.addHoverZoom(img, container);
      }
      
      // Add click zoom if enabled
      if (this.settings.fullscreenEnabled) {
        this.addClickZoom(img);
      }
    });
  }

  initClickOnly() {
    // For mobile when hover is disabled but click is enabled
    if (!this.settings.fullscreenEnabled) return;

    this.images = document.querySelectorAll('.product__media img, .product-media-container img');
    this.images.forEach(img => {
      const container = img.closest('.product__media, .product-media-container');
      if (container) {
        container.style.cursor = 'pointer';
        this.addClickZoom(img);
      }
    });
  }

  addHoverZoom(img, container) {
    let zoomOverlay = null;
    let zoomedImage = null;

    container.addEventListener('mouseenter', () => {
      // Don't show hover zoom on mobile unless enabled
      if (this.isMobile && !this.settings.mobileEnabled) return;

      // Create zoom overlay
      zoomOverlay = document.createElement('div');
      zoomOverlay.className = 'image-zoom-overlay';
      
      // Different styles based on hover style setting
      const overlayStyles = this.getOverlayStyles();
      zoomOverlay.style.cssText = overlayStyles;

      // Create zoomed image
      zoomedImage = document.createElement('img');
      zoomedImage.src = img.src;
      
      const imageStyles = this.getZoomedImageStyles(img);
      zoomedImage.style.cssText = imageStyles;

      zoomOverlay.appendChild(zoomedImage);
      container.style.position = 'relative';
      container.appendChild(zoomOverlay);
    });

    container.addEventListener('mousemove', (e) => {
      if (!zoomedImage || !zoomOverlay) return;

      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // Calculate zoom position
      const xPercent = x / rect.width;
      const yPercent = y / rect.height;

      const moveX = (img.naturalWidth * this.settings.zoomLevel - rect.width) * xPercent;
      const moveY = (img.naturalHeight * this.settings.zoomLevel - rect.height) * yPercent;

      // Apply transform based on hover style
      if (this.settings.hoverStyle === 'lens') {
        // Lens style - show a circular magnified area
        zoomOverlay.style.width = '200px';
        zoomOverlay.style.height = '200px';
        zoomOverlay.style.borderRadius = '50%';
        zoomOverlay.style.left = `${x - 100}px`;
        zoomOverlay.style.top = `${y - 100}px`;
        zoomOverlay.style.border = '3px solid rgba(255, 255, 255, 0.8)';
      } else if (this.settings.hoverStyle === 'follow') {
        // Follow cursor - zoomed area follows cursor
        const followSize = 300;
        zoomOverlay.style.width = `${followSize}px`;
        zoomOverlay.style.height = `${followSize}px`;
        zoomOverlay.style.left = `${Math.max(0, Math.min(x - followSize / 2, rect.width - followSize))}px`;
        zoomOverlay.style.top = `${Math.max(0, Math.min(y - followSize / 2, rect.height - followSize))}px`;
        zoomOverlay.style.border = '2px solid rgba(255, 255, 255, 0.5)';
      }

      zoomedImage.style.transform = `scale(${this.settings.zoomLevel}) translate(-${moveX / this.settings.zoomLevel}px, -${moveY / this.settings.zoomLevel}px)`;
    });

    container.addEventListener('mouseleave', () => {
      if (zoomOverlay) {
        zoomOverlay.remove();
        zoomOverlay = null;
        zoomedImage = null;
      }
    });
  }

  getOverlayStyles() {
    const baseStyles = `
      position: absolute;
      overflow: hidden;
      pointer-events: none;
      z-index: 10;
      transition: all 0.1s ease;
    `;

    if (this.settings.hoverStyle === 'overlay') {
      return baseStyles + `
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      `;
    } else if (this.settings.hoverStyle === 'lens') {
      return baseStyles + `
        width: 200px;
        height: 200px;
        border-radius: 50%;
        border: 3px solid rgba(255, 255, 255, 0.8);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      `;
    } else if (this.settings.hoverStyle === 'follow') {
      return baseStyles + `
        width: 300px;
        height: 300px;
        border: 2px solid rgba(255, 255, 255, 0.5);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      `;
    }
    
    return baseStyles;
  }

  getZoomedImageStyles(img) {
    return `
      position: absolute;
      max-width: none;
      width: ${img.naturalWidth}px;
      height: ${img.naturalHeight}px;
      transform-origin: top left;
    `;
  }

  addClickZoom(img) {
    img.addEventListener('click', (e) => {
      e.preventDefault();
      this.openFullscreen(img);
    });
  }

  openFullscreen(img) {
    // Store original overflow state
    this.originalOverflow = document.body.style.overflow;
    
    // Convert hex to rgba
    const bgColor = this.hexToRgba(this.settings.fullscreenBg, this.settings.fullscreenOpacity);
    
    // Create fullscreen modal
    const modal = document.createElement('div');
    modal.className = 'image-zoom-modal';
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${bgColor};
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      cursor: zoom-out;
      overflow: auto;
      animation: fadeIn 0.3s ease;
    `;

    // Create fullscreen image
    const fullImg = document.createElement('img');
    fullImg.src = img.src.replace(/_(small|medium|large|compact|grande)\./, '.'); // Get highest quality
    fullImg.style.cssText = `
     // max-width: 90%;
     // max-height: 90%;
      height: auto;
      width:90vw;
      object-fit: contain;
      animation: zoomIn 0.3s ease;
    `;

    // Create close button
    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = '×';
    closeBtn.setAttribute('aria-label', 'Close zoom view');
    closeBtn.style.cssText = `
      position: absolute;
      top: 20px;
      right: 30px;
      background: rgba(255, 255, 255, 0.9);
      border: none;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      font-size: 30px;
      cursor: pointer;
      z-index: 10000;
      transition: transform 0.2s;
    `;

    closeBtn.addEventListener('mouseenter', () => {
      closeBtn.style.transform = 'scale(1.1)';
    });

    closeBtn.addEventListener('mouseleave', () => {
      closeBtn.style.transform = 'scale(1)';
    });

    // Store modal reference
    this.activeModal = modal;

    // Close functionality
    const closeModal = () => {
      modal.style.animation = 'fadeOut 0.3s ease';
      setTimeout(() => {
        modal.remove();
        // Restore original overflow when modal is removed
        document.body.style.overflow = this.originalOverflow;
        this.activeModal = null;
      }, 300);
    };

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    // Escape key handler
    const escHandler = (e) => {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', escHandler);
      }
    };
    document.addEventListener('keydown', escHandler);

    modal.appendChild(fullImg);
    modal.appendChild(closeBtn);
    document.body.appendChild(modal);

    // Prevent body scroll only while modal is open
    document.body.style.overflow = 'hidden';
  }

  hexToRgba(hex, alpha) {
    // Remove # if present
    hex = hex.replace('#', '');
    
    // Parse hex values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}

// Add CSS animations
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  @keyframes fadeOut {
    from { opacity: 1; }
    to { opacity: 0; }
  }
  
  @keyframes zoomIn {
    from {
      transform: scale(0.8);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  .image-zoom-modal img {
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  }
`;
document.head.appendChild(style);

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductImageZoom();
  });
} else {
  new ProductImageZoom();
}

// Re-initialize on dynamic content changes (variant changes, etc.)
document.addEventListener('product:media-changed', () => {
  new ProductImageZoom();
});

// Listen for theme editor changes and reinitialize
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new ProductImageZoom();
  });
  
  document.addEventListener('shopify:section:reorder', () => {
    new ProductImageZoom();
  });
}



// Enhanced Product Image Zoom with Hover and Click
// Fixed version - resolves scrolling issue

// class ProductImageZoom {
//   constructor() {
//     this.images = document.querySelectorAll('.product__media img, .product-media-container img');
//     this.zoomLevel = 2;
//     this.activeModal = null;
//     this.originalOverflow = '';
//     this.init();
//   }

//   init() {
//     this.images.forEach(img => {
//       const container = img.closest('.product__media, .product-media-container');
//       if (!container) return;

//       // Add zoom cursor
//       container.style.cursor = 'zoom-in';
      
//       // Hover zoom functionality
//       this.addHoverZoom(img, container);
      
//       // Click to open full image
//       this.addClickZoom(img);
//     });
//   }

//   addHoverZoom(img, container) {
//     let zoomOverlay = null;
//     let zoomedImage = null;

//     container.addEventListener('mouseenter', () => {
//       // Create zoom overlay
//       zoomOverlay = document.createElement('div');
//       zoomOverlay.className = 'image-zoom-overlay';
//       zoomOverlay.style.cssText = `
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         overflow: hidden;
//         pointer-events: none;
//         z-index: 10;
//       `;

//       // Create zoomed image
//       zoomedImage = document.createElement('img');
//       zoomedImage.src = img.src;
//       zoomedImage.style.cssText = `
//         position: absolute;
//         max-width: none;
//         width: ${img.naturalWidth}px;
//         height: ${img.naturalHeight}px;
//         transform-origin: top left;
//       `;

//       zoomOverlay.appendChild(zoomedImage);
//       container.style.position = 'relative';
//       container.appendChild(zoomOverlay);
//     });

//     container.addEventListener('mousemove', (e) => {
//       if (!zoomedImage || !zoomOverlay) return;

//       const rect = container.getBoundingClientRect();
//       const x = e.clientX - rect.left;
//       const y = e.clientY - rect.top;

//       // Calculate zoom position
//       const xPercent = x / rect.width;
//       const yPercent = y / rect.height;

//       const moveX = (img.naturalWidth * this.zoomLevel - rect.width) * xPercent;
//       const moveY = (img.naturalHeight * this.zoomLevel - rect.height) * yPercent;

//       zoomedImage.style.transform = `scale(${this.zoomLevel}) translate(-${moveX / this.zoomLevel}px, -${moveY / this.zoomLevel}px)`;
//     });

//     container.addEventListener('mouseleave', () => {
//       if (zoomOverlay) {
//         zoomOverlay.remove();
//         zoomOverlay = null;
//         zoomedImage = null;
//       }
//     });
//   }

//   addClickZoom(img) {
//     img.addEventListener('click', (e) => {
//       e.preventDefault();
//       this.openFullscreen(img);
//     });
//   }

//   openFullscreen(img) {
//     // Store original overflow state
//     this.originalOverflow = document.body.style.overflow;
    
//     // Create fullscreen modal
//     const modal = document.createElement('div');
//     modal.className = 'image-zoom-modal';
//     modal.style.cssText = `
//       position: fixed;
//       top: 0;
//       left: 0;
//       width: 100%;
//       height: 100%;
//       background: rgba(0, 0, 0, 0.95);
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       z-index: 9999;
//       cursor: zoom-out;
//       animation: fadeIn 0.3s ease;
//     `;

//     // Create fullscreen image
//     const fullImg = document.createElement('img');
//     fullImg.src = img.src.replace(/_(small|medium|large|compact|grande)\./, '.'); // Get highest quality
//     fullImg.style.cssText = `
//       max-width: 90%;
//       max-height: 90%;
//       object-fit: contain;
//       animation: zoomIn 0.3s ease;
//     `;

//     // Create close button
//     const closeBtn = document.createElement('button');
//     closeBtn.innerHTML = '×';
//     closeBtn.setAttribute('aria-label', 'Close zoom view');
//     closeBtn.style.cssText = `
//       position: absolute;
//       top: 20px;
//       right: 30px;
//       background: rgba(255, 255, 255, 0.9);
//       border: none;
//       border-radius: 50%;
//       width: 40px;
//       height: 40px;
//       font-size: 30px;
//       cursor: pointer;
//       z-index: 10000;
//       transition: transform 0.2s;
//     `;

//     closeBtn.addEventListener('mouseenter', () => {
//       closeBtn.style.transform = 'scale(1.1)';
//     });

//     closeBtn.addEventListener('mouseleave', () => {
//       closeBtn.style.transform = 'scale(1)';
//     });

//     // Store modal reference
//     this.activeModal = modal;

//     // Close functionality
//     const closeModal = () => {
//       modal.style.animation = 'fadeOut 0.3s ease';
//       setTimeout(() => {
//         modal.remove();
//         // Restore original overflow when modal is removed
//         document.body.style.overflow = this.originalOverflow;
//         this.activeModal = null;
//       }, 300);
//     };

//     closeBtn.addEventListener('click', closeModal);
//     modal.addEventListener('click', (e) => {
//       if (e.target === modal) closeModal();
//     });

//     // Escape key handler
//     const escHandler = (e) => {
//       if (e.key === 'Escape') {
//         closeModal();
//         document.removeEventListener('keydown', escHandler);
//       }
//     };
//     document.addEventListener('keydown', escHandler);

//     modal.appendChild(fullImg);
//     modal.appendChild(closeBtn);
//     document.body.appendChild(modal);

//     // Prevent body scroll only while modal is open
//     document.body.style.overflow = 'hidden';
//   }
// }

// // Add CSS animations
// const style = document.createElement('style');
// style.textContent = `
//   @keyframes fadeIn {
//     from { opacity: 0; }
//     to { opacity: 1; }
//   }
  
//   @keyframes fadeOut {
//     from { opacity: 1; }
//     to { opacity: 0; }
//   }
  
//   @keyframes zoomIn {
//     from {
//       transform: scale(0.8);
//       opacity: 0;
//     }
//     to {
//       transform: scale(1);
//       opacity: 1;
//     }
//   }
  
//   .image-zoom-modal img {
//     box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
//   }
// `;
// document.head.appendChild(style);

// // Initialize when DOM is ready
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => {
//     new ProductImageZoom();
//   });
// } else {
//   new ProductImageZoom();
// }

// // Re-initialize on dynamic content changes (variant changes, etc.)
// document.addEventListener('product:media-changed', () => {
//   new ProductImageZoom();
// });